<div (click)="$event.stopPropagation()" *ngIf="permissionDialog">
  <div (click)='$event.stopPropagation()' class='modal-header'>
    <h4 class='modal-title d-flex align-items-start'>
      <pt-entity-icon [entity]='permissionDialog.entity'
                      [width]='20' style="display: inline-flex;align-items: center;height: 40px; margin-right: 2px;}">
      </pt-entity-icon>
      <span class="ms-2">{{ "TITLE.PERMISSIONS" | translate }}
      </span>
    </h4>
  </div>

  <div (click)='$event.stopPropagation()' class='modal-body'>
    <p>{{ "MESSAGE.PERMISSIONS" | translate }}</p>
    <form [formGroup]="formGroup">
      <pt-input-document-permission-selector
        [isAdmin]="isAdminOrSystem"
        [accessValue]="accessValue"
        [actionValue]="actionValue"
        [controlName]='"permissions"'
        [label]="'LABELS.MEMBERS' | translate"
        [ownerId]="permissionDialog.docCreatorUserId"
        [placeholder]="'LABELS.ADD_USERS_OR_USERS_GROUPS' | translate"
        formControlName='permissions'
      ></pt-input-document-permission-selector>
    </form>
  </div>

  <div (click)='$event.stopPropagation()' class='modal-footer'>

    <ng-container *ngIf="editable">
      <pt-button-with-loader

        (buttonWithLoaderClick)='save();'
        [cssClass]=''
        [disabled]='formGroup?.invalid || loadingSave'
        [label]="'BUTTON.SAVE' | translate"
        [loading]='loadingSave'
        [mainIcon]=''
      ></pt-button-with-loader>

      <button (click)='activeModal.close(false); $event.stopPropagation()' class='btn btn-outline-secondary btn-sm'
              type='button'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </ng-container>

    <ng-container *ngIf="!editable">
      <button (click)='activeModal.close(false); $event.stopPropagation()' class='btn btn-outline-secondary btn-sm'
              type='button'>
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </ng-container>

  </div>

</div>
